import { render, staticRenderFns } from "./LoyaltyCardPage.vue?vue&type=template&id=0cadb5f2&scoped=true&"
import script from "./LoyaltyCardPage.vue?vue&type=script&lang=js&"
export * from "./LoyaltyCardPage.vue?vue&type=script&lang=js&"
import style0 from "../../less/gift.less?vue&type=style&index=0&id=0cadb5f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cadb5f2",
  null
  
)

export default component.exports